import React from "react";
import Overflow from "react-overflow-indicator";

const overflow = (props) => (
  <Overflow style={{ maxHeight: props.maxHeight }}>
    <Overflow.Content>{props.children}</Overflow.Content>
    <Overflow.Indicator direction="down">
      <i
        className="icon ti-angle-double-down"
        style={{ position: "absolute", right: 10, bottom: 10 }}
        aria-hidden="true"
      ></i>
    </Overflow.Indicator>
  </Overflow>
);

export default overflow;
